<template>
    <jb-buttons no-wrap>
        <jb-button color="warning" class="buttons" :icon="mdiMagnify" small @click="showDetail" />
        <jb-button color="success" class="buttons" :icon="mdiCircleEditOutline" small @click="editClass" v-if="!this.params.data.is_sync_google_classroom || this.params.data.is_sync_google_classroom == null" />
        <jb-button color="danger" class="buttons" :icon="mdiTrashCan" small @click="deleteAction" v-if="!this.params.data.is_sync_google_classroom || this.params.data.is_sync_google_classroom == null" />
    </jb-buttons>
</template>
<script>
    import JbButtons from '@/components/JbButtons'
    import JbButton from '@/components/JbButton'
    import { mdiCircleEditOutline, mdiTrashCan, mdiMagnify, mdiAccount } from '@mdi/js'
    export default {
        name: 'ButtonActionRender',
        components: {
            JbButtons,
            JbButton
        },
        setup (props) {
            return {
                mdiCircleEditOutline,
                mdiTrashCan,
                mdiAccount,
                mdiMagnify
            }
        },

        methods: {
            showDetail (event) {
                // the grid component can now be accessed via this.params.context.componentParent
                this.params.context.componentParent.detailData(event, this.params.data, this.params.data.id)
            },
            editClass (event) {
                // alert('halo')
                // the grid component can now be accessed via this.params.context.componentParent
                this.params.context.componentParent.editData(event, this.params.data)
            },
            deleteAction () {
                this.params.context.componentParent.deleteModalShow(this.params.data)
            }
        }

    }
</script>
